import React, { createContext, useContext } from "react";

const InputGroupContext = createContext(null);

export function useInputGroupWidth() {
  return useContext(InputGroupContext);
}

export default InputGroupContext;
